import React, { useState } from "react";
import { IconButton, Flex, Text } from "@chakra-ui/react";
import { CalendarItem } from "./CalendarItem";
import { CalendarBodyRows } from "./CalendarBodyRows";
import { ChakraFAIcon } from "@/components/ui/Icon";
import {
	calculateState,
	getCurrentMonthYear,
	getMonthYearFromDate,
	getPreviousMonthYear,
	getNextMonthYear,
	formatMonthYear,
} from "../utils";
import { colours } from "@/theme/colours";

export interface Props {
	initialStartDate: Date | null;
	onSelect: (date: Date) => void;
}

export function SingleDatePicker(props: Props): JSX.Element {
	const [currentMonthYear, setCurrentMonthYear] = useState(
		props.initialStartDate ? getMonthYearFromDate(props.initialStartDate) : getCurrentMonthYear()
	);

	const onCalendarItemClick = (date: Date) => {
		props.onSelect(date);
	};

	return (
		<Flex flexDir="column" borderRadius="md" boxShadow="md" bgColor="neutrals.0">
			<Flex flexDir="column" p={3} gap={2}>
				<Flex
					flexDir="row"
					alignItems="center"
					justifyContent="space-between"
					bgColor="neutrals.10"
					mx="auto"
					borderRadius="md"
					width={"100%"}
				>
					<IconButton
						variant="ghost"
						size="sm"
						aria-label="Left Arrow"
						icon={<ChakraFAIcon icon={"fa-angle-left"} />}
						onClick={() => {
							setCurrentMonthYear(getPreviousMonthYear(currentMonthYear, 1));
						}}
					/>
					<Text fontSize="sm" fontWeight={500} color={colours.neutrals[800]}>
						{formatMonthYear(currentMonthYear)}
					</Text>
					<IconButton
						variant="ghost"
						size="sm"
						aria-label="Right Arrow"
						icon={<ChakraFAIcon icon={"fa-angle-right"} />}
						onClick={() => {
							setCurrentMonthYear(getNextMonthYear(currentMonthYear, 1));
						}}
					/>
				</Flex>
				<Flex flexDir="column" alignItems="center">
					<Flex flexDir="row" mb={2}>
						<CalendarItem label="Mo" isSelectable={false} weekdayIndicator />
						<CalendarItem label="Tu" isSelectable={false} weekdayIndicator />
						<CalendarItem label="We" isSelectable={false} weekdayIndicator />
						<CalendarItem label="Th" isSelectable={false} weekdayIndicator />
						<CalendarItem label="Fr" isSelectable={false} weekdayIndicator />
						<CalendarItem label="Sa" isSelectable={false} weekdayIndicator />
						<CalendarItem label="Su" isSelectable={false} weekdayIndicator />
					</Flex>
					<CalendarBodyRows
						currentMonthYear={currentMonthYear}
						calculateState={(date: Date) => calculateState(date, props.initialStartDate || undefined)}
						onCalendarItemClick={onCalendarItemClick}
					/>
				</Flex>
			</Flex>
		</Flex>
	);
}
